export default {
  subtitle: "深入分析歐盟 CBAM 碳合規，幫助中小企業快速了解法規和市場趨勢",
  feature1: "CBAM 介紹",
  feature2: "合規流程",
  feature3: "市場趨勢",
  feature4: "我們的產品如何幫助企業",
  seo_title: "歐盟 CBAM 碳合規指南",
  section1_title: "CBAM 介紹",
  section1_content1: "歐盟碳邊境調整機制 (CBAM) 是歐盟為應對氣候變化而引入的一項重要政策措施。",
  section1_content2:
    "該機制旨在防止碳洩漏，確保進口商品與歐盟內部生產的商品在碳排放成本方面處於公平競爭環境。",
  section1_content3:
    "CBAM 要求某些碳密集型商品的進口商購買相應的碳排放證書，以反映歐盟生產商所承擔的碳成本。",
  section2_title: "合規流程",
  section2_content: "CBAM 合規流程包括四個關鍵步驟：",
  section2_step1: "申報：進口商必須在 CBAM 系統中註冊，並定期申報進口商品的碳排放量",
  section2_step2: "核實：申報的碳排放數據必須經過獨立審計機構的核實",
  section2_step3: "購買證書：根據核實的排放數據購買相應的 CBAM 證書",
  section2_step4: "海關：只有在完成 CBAM 證書購買後，商品才能進入歐盟市場",
  section3_title: "市場趨勢",
  section3_content: "CBAM 仍在不斷發展和擴展，主要趨勢如下：",
  section3_trend1: "範圍擴展：CBAM 將逐步擴展到更多行業，包括有機化學品和塑膠產品",
  section3_trend2: "標準更嚴格：歐盟將持續提高碳排放計算的精確度和透明度要求",
  section3_trend3: "全球影響：CBAM 正在推動全球貿易夥伴建立或調整自己的碳定價機制",
  section3_trend4: "技術發展：數位工具和自動化系統在碳排放計算中發揮越來越重要的作用",
  section4_title: "我們的產品如何幫助企業",
  section4_content: "我們的產品可以幫助企業有效履行 CBAM 要求：",
  section4_benefit1: "精確計算：基於歐盟官方係數和自訂係數提供精確的碳排放計算",
  section4_benefit2: "高效合規：自動產生 CBAM 相容報告，簡化合規申報流程",
  section4_benefit3: "批次處理：支援大量數據處理，提高工作效率",
  section4_benefit4: "API 整合：輕鬆與 ERP 和電商系統整合，實現自動化合規報告",
  download_title: "立即下載白皮書",
  email_placeholder: "請輸入您的電子郵箱地址",
  agreement_text: "我同意使用此電子郵箱接收白皮書，並同意根據 GDPR 要求處理我的個人數據。",
  privacy_policy: "查看隱私政策",
  download_button: "下載白皮書 (PDF)",
  download_generating: "產生中...",
  email_required: "請輸入您的電子郵箱地址",
  agreement_required: "請同意隱私政策",
  download_success: "白皮書下載成功，感謝您使用我們的服務！",
  download_failed: "下載失敗，請稍後再試",
  submit_error: "提交失敗，請稍後再試",
};
